import { status } from 'skin/event/status'

const row = (obj, table, story, d, action) => {
    if (obj.current) return status.ignore
	return status.action
}

export default row